import api from "@/utils/api";

export const getUserInfo = async () => {
  return api.get("/users/me");
};

export const getUserList = async (companyId: number) => {
  return api.get("/users", {
    params: {
      companyId,
    },
  });
};

export const createUser = async (data: { email: string; role: string }) => {
  return api.post("/users", data);
};

export const deleteUser = async (id: number) => {
  return api.delete(`/users/${id}`);
};
